const siteUrl =
  process.env.REACT_APP_SITE_URL || "http://localhost/onuratabaycom";

export const siteConfig = {
  siteName: "Onur Atabay",
  siteUrl,
  defaultTitle: "Onur Atabay | Frontend Architect & Product Builder",
  titleTemplate: "%s | Onur Atabay",
  defaultDescription:
    "Onur Atabay'in kisisel web sitesi: premium React arayuzleri, headless CMS mimarisi, MyAppShop projeleri ve blog icerikleri.",
  defaultImage: `${siteUrl}/logo512.png`,
  locale: "tr_TR",
  twitterHandle: "@onuratabay",
  themeColor: "#090b11",
  keywords: [
    "Onur Atabay",
    "React developer",
    "frontend architect",
    "headless WordPress",
    "premium web sitesi",
    "tasarim sistemi",
    "MyAppShop",
  ],
};

export function buildCanonicalUrl(pathname = "/") {
  const normalizedPath = pathname === "/" ? "" : pathname.replace(/\/$/, "");

  return `${siteConfig.siteUrl}${normalizedPath || "/"}`;
}
